import { Schema } from 'zod'
import * as Z from 'zod'
import { success, validationFailure, Validator } from './responses'

export const validateSchema = <D>(schema: Schema<D>): Validator<D> => (
  input: unknown
) => {
  const result = schema.safeParse(input)
  if (result.success === true) {
    return success(result.data)
  } else {
    console.error(result.error)
    throw validationFailure(result.error.flatten())
  }
}

export const VoidSchema = Z.void()
export const validateVoid = validateSchema(VoidSchema)

export const UknownSchema = Z.unknown()
export const validateUnknown = validateSchema(UknownSchema)
